import type { AppServices } from '@/types/services.types';

export function registerBeforeUnloadHandler(getServices: () => AppServices): void {
  window.addEventListener('beforeunload', () => {
    void getServices().pocServices.p2pStackManagerService.shutdownNode();
  });
}
